import { ProjectStatus } from './project-status';

export class DsProject {
  /**
   *
   */
  public cle: string | null = null;

  /**
   *
   */
  public client: string | null = null;

  /**
   *
   */
  public g_basepath = '';

  /**
   *
   */
  public g_c: string | null = '';

  /**
   *
   */
  public g_createdate = 0;

  /**
   *
   */
  public g_desc = '';

  /**
   *
   */
  public g_id: number | null = null;

  /**
   *
   */
  public g_infos: string | null = '';

  /**
   *
   */
  public g_internalname = '';

  /**
   *
   */
  public g_maintenance: number | null = 0;

  /**
   *
   */
  public g_nom = '';

  /**
   *
   */
  public g_photo = '';

  /**
   *
   */
  public g_running: number | null = 1;

  /**
   *
   */
  public g_serverinfos: string | null = '';

  /**
   *
   */
  public g_xml = '';

  /**
   *
   */
  public hash2 = '';

  /**
   *
   */
  public lastactivity: string | null = null;

  /**
   *
   */
  public linkemail: number | null = null;

  /**
   *
   */
  public serial: string | null = null;

  /**
   *
   */
  public server_time: number | null = 0;

  /**
   *
   */
  public server_update_time: number | null = 0;

  /**
   *
   */
  public sxd_creationdate = 0;

  /**
   *
   */
  public sxd_typeClient = '';

  /**
   *
   */
  public templateMail = 'mail_rgoc2.php';

  /**
   *
   */
  public organisation_name: string | null = '';

  /**
   *
   */
  public organisation_id = 0;

  /**
   *
   */
  public timezone = '';

  /**
   *
   */
  archived: boolean;

  /**
   * Project status.
   */
  public status: ProjectStatus;

  /**
   * Creates an instance of DsProject.
   *
   * @param jsonData the json data
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(jsonData: any = {}) {
    this.cle = jsonData.cle ? jsonData.cle : this.cle;
    this.client = jsonData.client ? jsonData.client : this.client;
    this.g_basepath = jsonData.g_basepath ? jsonData.g_basepath : this.g_basepath;
    this.g_c = jsonData.g_c ? jsonData.g_c : this.g_c;
    this.g_createdate = jsonData.g_createdate ? jsonData.g_createdate : this.g_createdate;
    this.g_desc = jsonData.g_desc ? jsonData.g_desc : this.g_desc;
    this.g_id = jsonData.g_id ? jsonData.g_id : this.g_id;
    this.g_infos = jsonData.g_infos ? jsonData.g_infos : this.g_infos;
    this.g_internalname = jsonData.g_internalname ? jsonData.g_internalname : this.g_internalname;
    this.g_maintenance = jsonData.g_maintenance ? jsonData.g_maintenance : this.g_maintenance;
    this.g_nom = jsonData.g_nom ? jsonData.g_nom : this.g_nom;
    this.g_photo = jsonData.g_photo ? jsonData.g_photo : this.g_photo;
    this.g_running = jsonData.g_running ? jsonData.g_running : this.g_running;
    this.g_serverinfos = jsonData.g_serverinfos ? jsonData.g_serverinfos : this.g_serverinfos;
    this.g_xml = jsonData.g_xml ? jsonData.g_xml : this.g_xml;
    this.hash2 = jsonData.hash2 ? jsonData.hash2 : this.hash2;
    this.lastactivity = jsonData.lastactivity ? jsonData.lastactivity : this.lastactivity;
    this.linkemail = jsonData.linkemail ? jsonData.linkemail : this.linkemail;
    this.serial = jsonData.serial ? jsonData.serial : this.serial;
    this.server_time = jsonData.server_time ? jsonData.server_time : this.server_time;
    this.server_update_time = jsonData.server_update_time ? jsonData.server_update_time : this.server_update_time;
    this.sxd_creationdate = jsonData.sxd_creationdate ? jsonData.sxd_creationdate : this.sxd_creationdate;
    this.sxd_typeClient = jsonData.sxd_typeClient ? jsonData.sxd_typeClient : this.sxd_typeClient;
    this.templateMail = jsonData.templateMail ? jsonData.templateMail : this.templateMail;
    this.organisation_name = jsonData.organisation_name ? jsonData.organisation_name : this.organisation_name;
    this.organisation_id = jsonData.organisation_id ? jsonData.organisation_id : this.organisation_id;
    this.timezone = jsonData.timezone ? jsonData.timezone : this.timezone;
    this.archived = jsonData.archived === 1;
    this.status = new ProjectStatus(jsonData.status);
  }
}
